export default __webpack_public_path__ + "static/media/pleiq-caligrafix_color_logo.21a74e85.png";